window.ProfileController = class {

	options = {};
	constructor(options = {}) {
		this.tpl = $('#page');
		this.options = options;
	}

	regionInitialized = null;

	initialized = false;
	async init() {
		const self = this;

		if (this.initialized) {
			return;
		}
		this.initialized = true;

		this.tpl.on('click.ProfileController', '[data-trigger]', this.handleGlobalEvents);

		this.regionInitialized = this.initRegions();
		this.initBinds();
	}

	handleGlobalEvents = async(event) => {

		const target = event.currentTarget;
		target.disabled = true;

		let stopPropagation = true;
		let laddaButton = null;

		// Por default se hace un stop propagation
		// A menos que se defina el atributo data-allow-propagation
		// O que se haya disparado por el track event y no tenga un trigger
		if(target.dataset.allowPropagation !== undefined) {
			stopPropagation = false;
		}

		// Si es tipo button inicializar Ladda
		if(target.tagName === 'BUTTON') {
			if(!target.dataset.style) {
				target.dataset.style = 'zoom-out';
			}
			laddaButton = Ladda.create(target);
		}

		try {
			switch (target.dataset.trigger) {
				case 'Profile.closeMenu':
					this.closeMenu();
					break;
				case 'Profile.toggleMenu':
					this.toggleMenu();
					break;
				case 'Profile.modalSelect':
					this.modalSelect(target);
					break;

				case 'ActionRequired.verifyWhatsapp': {
					await Library.load(['WhatsAppComponent']);
					let options = {...target.dataset} // traerlo como objeto
					options.lockNumber = true; // impedir que pueda cambiarse el numero de telefono
					await new WhatsAppComponent(options).initVerify();
					target.closest('.action-required').remove();
					break;
				}

				case 'ActionRequired.verifyTelegram': {
					laddaButton?.start();
					await Library.load(['TelegramComponent']);
					let options = {...target.dataset} // traerlo como objeto
					options.lockNumber = true; // impedir que pueda cambiarse el numero de telefono
					await new TelegramComponent(options).initVerify();
					target.closest('.action-required').remove();
					break;
				}

				case 'ActionRequired.verifyEmail': {
					laddaButton?.start();
					await Library.load(['EmailComponent']);
					let options = {...target.dataset} // traerlo como objeto
					options.lockEmail = true; // impedir que pueda cambiarse el numero de telefono
					await new EmailComponent(options).initVerify();
					target.closest('.action-required').remove();
					break;
				}

				case 'ActionRequired.updateEmail': {
					laddaButton?.start();
					await Library.load(['EmailComponent']);
					await new EmailComponent().initChange();
					target.closest('.action-required').remove();
					break;
				}

				case 'ActionRequired.verifyId':
					laddaButton?.start();
					await Library.load(['IdVerificationComponent']);
					await new IdVerificationComponent().init();
					target.closest('.action-required').remove();
					break;

				//	Si ningun trigger matcheo, no hacer stopPropagation
				default:
					stopPropagation = false;
					break;
			}
		} catch (error) {
			ErrorHandler.log(error);
		} finally {

			if(stopPropagation) {
				event.stopPropagation();
			}

			target.disabled = false;
			laddaButton?.stop();
		}

	}

	async initRegions() {
		const self = this;

		let [response] = await Promise.all([
			fetch(`${NOW.settings.url_api}/regions`),
			Library.load(["select2region"]),
		]);

		let regionData = await response.json();
		Cache.Region = new CollectionHelper("id", regionData);

		self.tpl.find('select[name="pub_region"]').select2region({
			minRegionLevel: 2,
		});
	}

	async initBinds() {
		const self = this;

		try {
			let [regionData] = await Promise.all([
				Library.load(["intlTelInput", "select2", "TransactionComponent", "moment"]),
			]);

			this.tpl.find('input[name="pub_full_time"]').on("change", (event) => {
				// Dependiendo el estado, mostrar u ocultar los horarios detallados
				if (event.currentTarget.checked) {
					this.tpl.find(".working_time").hide();
				} else {
					this.tpl.find(".working_time").show();
				}
			}).trigger("change");

			this.tpl.find('input[name="weekly"]').on("change", function () {
				if ($(this).prop("checked")) {
					self.tpl.find(".weekly").show();
					self.tpl.find(".daily").hide();
				} else {
					self.tpl.find(".weekly").hide();
					self.tpl.find(".daily").show();
				}
			}).trigger("change");

			this.tpl.find(".working_time").find("input").on("change", function () {
				$(this).attr("value", $(this).val());
			});

			this.tpl.find(".working_time").find("button").on("click", function (e) {
				e.preventDefault();
				let parent = $(this).parent();
				parent.find("input").val(null).trigger("change");
				$(this).blur();
			});

			// remover segundos..
			for (let element of this.tpl.find('input[data-plugin="time"]')) {
				$(element)
					.attr("type", "text")
					.val(
						$(element)
							.val()
							.replace(/(\d+):(\d+):\d+/g, "$1:$2")
					);
			}

			this.tpl.find('input[data-plugin="time"]').timeDropper({
				minutesSteps: 15,
				setCurrentTime: false,
				mousewheel: true,
				meridians: false,
				format: "H:mm",
			});

			this.tpl.find("#pubEditForm").on("submit", async function (e) {
				e.preventDefault();
				let form = new FormHandler(e.target);
				if (form.lock()) return false;
				try {
					// REST
					let res = await axios.post(
						`${NOW.settings.url_api}/profile/pub`,
						form.serialize()
					);
					AlertUi.confirm(
						{
							title: '<i class="fa fa-exclamation-circle fa-2x"></i>',
							msg: "Configuración guardada.",
							type: "OK",
						},
						{
							autoclose: 1000,
						}
					);
				}
				catch(error) {
					ErrorHandler.process(error);
				}
				finally {
					// finalizo animacion y libero boton
					form.unlock();
				}
			});

			this.tpl.find('[data-trigger="Account.ChangePassword"]').on('click', async function () {
				const modal = new ModalUi();
				const [template] = await Promise.all([
					modal.loadFromServer('changePasswordView'),
					PhrasesService.load(['ERR_PASSWORDS_DO_NOT_MATCH']),
				]);

				function validatePassword() {
					const new_password = document.getElementsByName('new_password')[0];
					const confirm_password = document.getElementsByName('confirm_new_password')[0];
					(new_password.value !== confirm_password.value)
						? confirm_password.setCustomValidity(PhrasesService.get('ERR_PASSWORDS_DO_NOT_MATCH'))
						: confirm_password.setCustomValidity('');
				}

				template.find("input[name='new_password']").on('change', () => validatePassword());
				template.find("input[name='confirm_new_password']").on('keyup', () => validatePassword());
				template.find('form').on('submit', async function (e) {
					e.preventDefault();
					const form = new FormHandler(e.target);
					if (form.lock()) return false;
					try {
						await Promise.all([
							axios.post(`${NOW.settings.url_api}/profile/account/password`, form.serialize()),
							PhrasesService.load(['ACCOUNT_PASSWORD_UPDATED', 'ACCOUNT_PASSWORD_UPDATED_DESCRIPTION']),
						]);
						AlertUi.confirm({
							title: PhrasesService.get('ACCOUNT_PASSWORD_UPDATED'),
							msg: PhrasesService.get('ACCOUNT_PASSWORD_UPDATED_DESCRIPTION'),
							type: 'OK',
						});
						modal.hide();
					} catch (error) {
						ErrorHandler.process(error);
					}
					form.unlock();
				});

				modal.render(template);

			});

			this.tpl.find('[data-trigger="Account.DeleteAccount"]').on('click', this.handleDeleteAccount);


			this.tpl.find('[data-trigger="Profile.viewActiveSessions"]').on('click', async function () {
				try {
					// Bloquear boton para evitar multiples clicks
					this.setAttribute('disabled', true);

					const res = await axios.get(`/api/profile/sessions`);
					const modal = new ModalUi();
					const $modal = await modal.loadFromHTML(res.data.modal);
					modal.render();

					$modal.find('button[role="revoke"]').on('click', async function (e) {

						try {
							// Bloquear boton usando ladda para efecto de carga
							var l = Ladda.create(this);
							l.start();

							const login_id = $(this).data('login_id');
							await axios.delete(`/api/profile/sessions/${login_id}`);

							// Remover la sesion de la lista
							$modal.find(`[data-login_id='${login_id}']`).remove();

							// Si no quedan sesiones para revocar, ocultar boton de revocar todas
							if ($modal.find('[data-can-revoke="1"]').length == 0) {
								$modal.find('button[role="revokeAll"]').remove();
							}
						} catch (error) {
							AlertUi.error(null, error?.response?.data?.message);
						} finally {
							l.stop();
						}
					});
					$modal.find('button[role="revokeAll"]').on('click', async function () {
						try {
							var l = Ladda.create(this);
							l.start();
							await axios.delete(`/api/profile/sessions`);
							// Remover todas las sesiones de la lista
							$modal.find('[data-can-revoke="1"]').remove();
							// Remover boton de revocar todas
							$(this).remove();
						} catch (error) {
							AlertUi.error(null, error?.response?.data?.message);
						} finally {
							l.stop();
						}
					});
				} catch (e) {
					AlertUi.error(null, e?.response?.data?.message);
				} finally {
					// Desbloquear boton
					this.removeAttribute('disabled');
				}
			});

			this.tpl.find('[data-trigger="Profile.viewWebAuth"]').on('click', async function () {
				try {
					// Bloquear boton para evitar multiples clicks
					this.setAttribute('disabled', true);

					const res = await axios.get(`/api/profile/webauthn`);
					const modal = new ModalUi();
					const $modal = await modal.loadFromHTML(res.data.modal);
					modal.render();

					$modal.find('button[role="register"]').on('click', async function () {
						await NOW.authService.registerWebAuth();
						modal.hide();
					});

					$modal.find('button[role="revoke"]').on('click', async function () {

						try {
							// Bloquear boton usando ladda para efecto de carga
							var l = Ladda.create(this);
							l.start();

							const webauth_id = $(this).data('webauth_id');
							await axios.delete(`/api/profile/webauthn/${webauth_id}`);
							// Remover la sesion de la lista
							$modal.find(`[data-webauth_id='${webauth_id}']`).remove();

						} catch (error) {
							AlertUi.error(null, error?.response?.data?.message);
						} finally {
							l.stop();
						}
					});

				} catch (error) {
					ErrorHandler.process(error);
				} finally {
					// Desbloquear boton
					this.removeAttribute('disabled');
				}
			});

			this.tpl.find(".tab-content").removeClass("d-none");

			this.tpl.find('input[name="pub_whatsapp"][readonly]').on("click", this.handleChangeWhatsappNumber);

			this.tpl.find('input[name="pub_telegram"][readonly]').on("click", this.handleChangeTelegramNumber);

			this.tpl.find(".account-menu-content-trigger").swipe({
				swipeLeft: function (
					event,
					direction,
					distance,
					duration,
					fingerCount
				) {
					self.closeMenu();
				},
			});

			this.tpl.find("button[role='buyPlan']").on('click', async function () {
				await Library.load(["TransactionComponent", "datatable", "moment"]);
				TransactionComponent.orderPage();
			});

			this.tpl.find("button[role='pending-orders']").on('click', function handlePendingOrdersClick() {
				axios.get(`${NOW.settings.url_api}/transactions/orders/pending`)
					.then((response) => {
						const modal = new ModalUi();
						modal.loadFromHTML(response.data);
						modal.render();
					}, () => {
					});
			});

			this.tpl.find('button[role="pause-on"]').on('click', async function handlePauseOn() {
				const modal = new ModalUi();
				let [$modal] = await Promise.all([
					modal.loadFromServer('status-pause', {}),
				]);
				modal.render();

				$modal.on('submit', async function (e) {

					e.preventDefault();
					let form = new FormHandler(e.target);
					if (form.lock()) return false;

					try {
						let res = await axios.post(`${NOW.settings.url_api}/profile/mode/pause`, form.serialize());
						location.reload();
					} catch (err) {

						AlertUi.confirm({
							'title': 'Oops',
							'msg': err?.response?.data?.message || err,
							'type': 'OK',
						});
					}
					// finalizo animacion y libero boton
					form.unlock();
				});
			});

			this.tpl.find('button[role="pause-off"]').on('click', async function handlePauseOff() {

				await Promise.all([
					PhrasesService.load(['PAUSE_OFF_TITLE', 'PAUSE_OFF_MSG', 'PAUSE_OFF']),
				]);

				AlertUi.modal({
					'title': PhrasesService.get('PAUSE_OFF_TITLE'),
					'msg': PhrasesService.get('PAUSE_OFF_MSG'),
					'type': PhrasesService.get('PAUSE_OFF'),
					'dismiss': 'cancel',
				}).then(async function () {
					try {
						let res = await axios.delete(`${NOW.settings.url_api}/profile/mode/pause`);
						location.reload();
					} catch (err) {
						AlertUi.confirm({
							'title': 'Oops',
							'msg': err?.response?.data?.message || err,
							'type': 'OK',
						});
					}
				}, () => {
				});
			});

			this.tpl.find('button[role="holidays-on"]').on('click', async function handleHolidaysOn() {
				const modal = new ModalUi();
				let [$modal, countries] = await Promise.all([
					modal.loadFromServer('status-holidays', {}),
					Library.load(['datepicker']),
				]);

				$modal.find('[data-plugin="datepicker"]').datepicker({
					language: "es",
					autoclose: true,
					todayHighlight: true,
					format: 'dd/mm/yyyy',
				});

				modal.render();

				$modal.on('submit', async function (e) {

					e.preventDefault();
					let form = new FormHandler(e.target);
					if (form.lock()) return false;

					try {

						form.convertDate('pub_holidays_date', 'DD/MM/YYYY', 'YYYY-MM-DD');

						let res = await axios.post(`${NOW.settings.url_api}/profile/pub`, form.serialize());
						location.reload();

					} catch (err) {

						AlertUi.confirm({
							'title': 'Oops',
							'msg': err?.response?.data?.message || err,
							'type': 'OK',
						});
					}
					// finalizo animacion y libero boton
					form.unlock();
				});
			});

			this.tpl.find('button[role="holidays-off"]').on('click', async function handleHolidaysOff() {

				try {
					let res = await axios.delete(`${NOW.settings.url_api}/profile/mode/holidays`);
					location.reload();

				} catch (err) {
					AlertUi.confirm({
						'title': 'Oops',
						'msg': err?.response?.data?.message || err,
						'type': 'OK',
					});
				}
			});

			this.tpl.find('#bannerUpload').dropzone({
				url: `${NOW.settings.url_api}/profile/banner`,
				method: "post",
				timeout: 300000,
				maxFilesize: 5,
				createImageThumbnails: false,
				acceptedFiles: 'image/*',
				success: function (response) {
					response = JSON.parse(response.xhr.response);
					console.log(response);
					self.tpl.find('#bannerImg').attr('src', `${NOW.settings.url_media}/${NOW.session.user_id}/banner.jpg?${response.banner_uploaded || '0'}`);
					//Messenger().post("Se modificó la foto de perfil.");
				},
			});

			this.tpl.find('[role="avatarUpload"]').dropzone({
				url: `${NOW.settings.url_api}/profile/avatar`,
				method: "post",
				timeout: 300000,
				maxFilesize: 20,
				createImageThumbnails: false,
				acceptedFiles: 'image/*',
				success: function (response) {
					response = JSON.parse(response.xhr.response);

					self.tpl.find('.avatar img').attr('src', `${NOW.settings.url_media}/${NOW.session.user_id}/avatar.jpg?${response.avatar_uploaded || '0'}`);
					//Messenger().post("Se modificó la foto de perfil.");
				},
				// Error Handler
				error: async function (file, errorMessage, xhr) {
					try {
						// si el Token esta Expirado -> Hacemos Refresh del Token
						if (errorMessage.message == "Expired token") {
							if ((await Auth.refresh()) == true)
								// si llega hasta aca, el TokenRefresh esta OK. Reenviar File.
								this.uploadFile(file);
						}
					} catch (error) {
						console.log(error);
					}
				},
			});

			this.tpl.find('a[data-toggle="tab"][href="#account-analytics"]').one('shown.bs.tab', async function () {
				self.initAnalytics();
			});

			this.tpl.find('a[data-toggle="tab"][href="#account-trips"]').one('shown.bs.tab', async function () {
				self.initTrips();
			});

			this.tpl.find('a[data-toggle="tab"][href="#account-purchases"]').one('shown.bs.tab', async function () {
				self.initTransactions();
			});

			this.tpl.find('span[role="triggerUpload"]').on('click', function (e) {
				e.stopPropagation();
				window.scrollTo({top: 0, behavior: 'smooth'});
				$('#header-upload-trigger').click();
			});

			this.tpl.find('#newTrip').on('click', async function () {
				const modal = new ModalUi();
				let [$modal,] = await Promise.all([
					modal.loadFromServer('trip-new', {}),
					Library.load(['datepicker']),
				]);
				modal.render($modal);
				let instance = await $modal.find('select[name="trip_destination"]').select2region({
					minRegionLevel: 2,
					allowClear: false,
					customInputs: {
						country: 'trip_country',
						province: 'trip_province',
						city: 'trip_city',
						zone: 'trip_zone',
					},
					onChange: function (val) {
						$modal.find('button[type="submit"]').attr('disabled', false);
					},
					...(self.options.plan_overseas == 0 ? {allowedCountries: [self.options.pub_country]} : {}),
				});

				$modal.find('[data-plugin="datepicker"]').datepicker({
					inline: true,
					language: "es",
					autoclose: true,
					todayHighlight: true,
					format: 'dd/mm/yyyy',
				});
				$modal.find('[data-plugin="datepicker"]').on('changeDate', function () {
					$modal.find('#trip_date').val(
						$(this).datepicker('getFormattedDate')
					);
				});

				$modal.on('submit', async function (e) {

					e.preventDefault();
					let form = new FormHandler(e.target);
					if (form.lock()) return false;

					try {
						form.convertDate('trip_date', 'DD/MM/YYYY', 'YYYY-MM-DD');
						let newData = await axios.post(`${NOW.settings.url_api}/profile/trip`, form.serialize());
						self.tripTable.row.add(newData.data).draw(false);
						modal.hide();
					} catch (err) {

						AlertUi.confirm({
							'title': 'Oops',
							'msg': err?.response?.data?.message || err,
							'type': 'OK',
						});
					}
					// finalizo animacion y libero boton
					form.unlock();
				});
			});


			// Si se pasa por url un hash, cambiar de tab
			if (window.location.hash) {
				this.handleHashChange();
			}

			// Bind cambios en el hash - utilizamos para cambiar de tab
			window.addEventListener('hashchange', this.handleHashChange );

		} catch(error) {
			ErrorHandler.log(error);
		}
	}

	/**
	 * Cambia de tab segun el hash de la url
	 */
	handleHashChange = () => {
		const newHash = window.location.hash;
		this.tpl.find(`a[href="${window.location.hash}"]`).tab('show');
	}

	async initTrips() {
		const self = this;

		let [dataSrc] = await Promise.all([
			fetch("/api/profile/trips"),
			self.regionInitialized, // Esperar que termine de cargar initRegions
			Library.load(["datatable", "moment"]),
		]);

		[dataSrc] = await Promise.all([dataSrc.json()]);

		var settings = {
			sDom: "<'overflow-auto horizontal-scroll't>",
			destroy: true,
			scrollCollapse: true,
			oLanguage: {
				sLengthMenu: "_MENU_ ",
				sInfo: "Mostrando registros _START_ al _END_ de un total de _TOTAL_",
				sInfoEmpty:
					"Mostrando registros _START_ al _END_ de un total de _TOTAL_",
				sInfoFiltered: "(filtrado de un total de _MAX_)",
				sLoadingRecords: "Cargando...",
				sProcessing: "Cargando...",
				//"sLoadingRecords": '<img src="/dashboard/assets/images/table-loading.svg">',
				sSearch: "_INPUT_",
				sSearchPlaceholder: "Buscar..",
				oPaginate: {
					sNext: "Proximo",
					sPrevious: "Previo",
				},
				sZeroRecords: "<strong>No hay viajes agendados</strong>",
			},
			iDisplayLength: 30,
			order: [[0, "asc"]],
			bDeferRender: true,
			aaData: dataSrc,
			autoWidth: false,
			processing: true,
			columns: [
				{
					mData: "trip_date",
					sTitle: "",
					bSearchable: false,
					bSortable: true,
					className: "v-align-middle trip-cell",
					mRender: function (data, type, row) {
						if (type == "display")
							return `
								<h6 class="mb-0">${moment(data).format("ll")}</h6>
								<div class="font-size-16 d-flex align-items-center">
									<img loading="lazy" src="${
										NOW.settings.url_static
									}/images/country-flag/${Cache.Region.get(
								row.trip_country,
								"region_code"
							)}.svg" class="trip-flag h-20 pr-10">
									<div class="trip-destination">${Cache.Region.get(
										row.trip_country,
										"text"
									)}</div>
									<div class="trip-destination trip-separator">${Cache.Region.get(
										row.trip_province,
										"text"
									)}</div>
									<div class="trip-destination trip-separator">${Cache.Region.get(
										row.trip_city,
										"text"
									)}</div>
									<div class="trip-destination trip-separator pr-10">${Cache.Region.get(
										row.trip_zone,
										"text"
									)}</div>
								</div>
							`;
						return data;
					},
				},
				{
					mData: "trip_id",
					sTitle: "",
					width: "1px",
					bSearchable: false,
					bSortable: false,
					className: "",
					mRender: function (data, type, row) {
						return `<button type="button" class="btn mx-auto" role="deleteTrip"><i class="fal fa-trash"></i></button>`;
					},
				},
			],
		};
		self.tripTable = self.tpl.find("#account-trips table").DataTable(settings);
		self.tpl.find("#account-trips").on(
			"click",
			'[role="deleteTrip"]',
			async function (e) {
				e.preventDefault();
				let tr = $(this).parents("tr:first");
				let data = self.tripTable.row(tr).data();
				try {
					await axios.delete(
						`${NOW.settings.url_api}/profile/trip/${data.trip_id}`
					);
					self.tripTable.row(tr).remove().draw(false);
				} catch (error) {
					ErrorHandler.process(error);
				}
			}
		);
	}

	async initAnalytics() {
		const self = this;

		var graph = {};

		var chartSettings = {
			tooltip: (label, date, values) => {
				var ret = `
					<div>
						<div><b>${moment(date * 1000).format(
														"dddd DD, MMMM YYYY"
													)}</b></div>`;
				for (let idx in label) {
					ret += `<div>${label[idx]} <b>${Intl.NumberFormat().format(
						values[idx]
					)}</b></div>`;
				}
				return ret + `</div>`;
			},
		};

		var render = function () {};

		// fetch
		let [dataView, dataEvent] = await Promise.all([
			fetch("/api/profile/stats"),
			fetch("/api/profile/stats_event"),
		]);

		[dataView, dataEvent] = await Promise.all([
			dataView.json(),
			dataEvent.json(),
		]);

		self.graphs = [
			new ChartUi(chartSettings),
			new ChartUi(chartSettings),
		];

		await Promise.all([
			self.graphs[0].draw(
				"#analytics-views",
				dataView,
				dataView.from,
				dataView.to
			),
			self.graphs[1].draw(
				"#analytics-events",
				dataEvent,
				dataView.from,
				dataView.to
			),
		]);

		self.graphs[0].redraw();
		self.graphs[1].redraw();
	}

	async initTransactions() {
		const self = this;

		await Library.load(["TransactionComponent", "datatable", "moment"]);
		TransactionComponent.purchasesPage( self.tpl.find("#account-purchases table") );
	}

	/**
	 * @description Procesa el envio del formulario de seleccion de opciones.
	 */
	async onSubmitModalSelect(ev, modal, $target) {
		try {
			ev.preventDefault();

			var form = new FormHandler(ev.currentTarget, ev);

			if (form.lock()) return false;

			// REST
			const res = await axios.post(
				`${NOW.settings.url_api}/profile/pub`,
				form.serialize()
			);
			// success
			let inputIds = [];

			$target.html("");
			for (let item of $(ev.currentTarget).find('option:selected')) {
				inputIds.push(item.value);
				$target.append(
					`<span class="account-tag">${item.text}</span>`
				);
			}
			$target.attr("data-selection", inputIds.join(","));

			await AlertUi.confirm(
				{
					title: '<i class="fa fa-exclamation-circle fa-2x"></i>',
					msg: "Configuración guardada.",
					type: "OK",
				},
				{
					autoclose: 1000,
				}
			);

			modal.hide();
		}
		catch (error) {
			ErrorHandler.process(error);
		}
		finally {
			// finalizo animacion y libero boton
			form.unlock();
		}
	}

	async modalSelect(trigger) {
		const self = this;
		var $target = self.tpl.find(`div[data-tag-type="${trigger.dataset.target}"]`);
		trigger.dataset.selection = $target.attr("data-selection");

		const modal = new ModalUi();

		// inicializar modal, generar contenido
		let $modal = await modal.loadFromServer(
			"modalSelect",
			{},
			trigger.dataset || {},
			true
		);
		// Renderizar en pantalla
		modal.render();

		$modal.find("form").on("submit",
			(ev) => this.onSubmitModalSelect(ev, modal, $target) );
	}

	closeMenu() {
		const self = this;

		self.tpl.find(".account-menu-container").addClass("menu-closed");
	}

	toggleMenu() {
		const self = this;

		self.tpl.find(".account-menu-container").toggleClass("menu-closed");
	}

	// Events..


	/**
	 * @description Inicializa el proceso de cambio de número de WhatsApp.
	 * @param event	- Evento de click
	 * @returns {Promise<void>}
	 */
	handleChangeWhatsappNumber = async(event) =>{
		try {
			event.currentTarget.disabled = true;

			await Library.load(['WhatsAppComponent']);

			const whatsapp = new WhatsAppComponent();
			const phone = await whatsapp.initVerify();

			// Actualizar intlTelInput Flag y valor del input
			const iti = window.intlTelInput.getInstance( event.currentTarget );
			iti.setNumber(phone);

		} catch(error) {
			ErrorHandler.process(error);
		} finally {
			event.currentTarget.disabled = false;
		}
	}

	/**
	 * @description Inicializa el proceso de cambio de número de Telegram.
	 * @param event	- Evento de click
	 * @returns {Promise<void>}
	 */
	 handleChangeTelegramNumber = async(event) =>{
		try {
			event.currentTarget.disabled = true;

			await Library.load(['TelegramComponent']);

			const telegram = new TelegramComponent();
			const phone = await telegram.initVerify();

			// Actualizar intlTelInput Flag y valor del input
			const iti = window.intlTelInput.getInstance( event.currentTarget );
			iti.setNumber(phone);

		} catch(error) {
			ErrorHandler.process(error);
		} finally {
			event.currentTarget.disabled = false;
		}
	}

	/**
	 * @description Elimina la cuenta del usuario actual.
	 * @returns {Promise<void>}
	 */
	handleDeleteAccount = async(event) => {
		try {
			event.currentTarget.disabled = true;

			// cargar frases y librerias
			await Promise.all([
				PhrasesService.load(['ACCOUNT_DELETE_CONFIRM', 'ACCOUNT_DELETE_CONFIRM_DESCRIPTION', 'ACCOUNT_DELETED', 'ACCOUNT_DELETED_DESCRIPTION']),
			]);

			// mostrar alerta de confirmacion
			await AlertUi.delete({
				'title': PhrasesService.get('ACCOUNT_DELETE_CONFIRM'),
				'msg': PhrasesService.get('ACCOUNT_DELETE_CONFIRM_DESCRIPTION'),
			});

			// Solicitar borrado de cuenta.
			await axios.delete(`${NOW.settings.url_api}/profile/account/delete`);

			// Mostrar mensaje de cuenta eliminada
			await AlertUi.modal({
				'title': PhrasesService.get('ACCOUNT_DELETED'),
				'msg': PhrasesService.get('ACCOUNT_DELETED_DESCRIPTION'),
				'type': 'OK',
			});

			// Redirigir a la pagina principal
			window.location.href = '/';

		} catch(error) {
			ErrorHandler.process(error);
		} finally {
			event.currentTarget.disabled = false;
		}
	}
};
